import React from "react";
import "./Loader.css";

const Loader = ({ show = false, message = "" }) =>
  show ? (
    <div>
      {/* <div className="overlay"></div> */}
      <div id="loader-primary" className="loader-container">
        <div className="spinner-border loader-spinner" style={{width: "3rem", height: "3rem"}} role="status">
          <span className="sr-only">Loading...</span>
        </div>
        {message && <div className="mt-3">{message}...</div>}
      </div>
    </div>
  ) : null;

export default Loader;
